/**
 * OmniKeys — Scroll Animations
 * Lightweight fade-in on scroll using IntersectionObserver
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initScrollAnimations() {
    const elements = document.querySelectorAll(
      '.ok-trust-badge-card, .ok-review-card, .ok-bundle-item, .ok-hiw-step, .ok-edu-card, .ok-cat-card'
    );

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ok-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el, i) => {
      el.classList.add('ok-fade-in');
      el.style.transitionDelay = `${(i % 4) * 0.08}s`;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(initScrollAnimations, 100);
  });
})();
